var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTrendDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 384C576 404.901 558.369 416 544 416H384C366.312 416 352 401.672 352 384S366.312 352 384 352H466.75L320 205.25L214.625 310.625C208.375 316.875 200.188 320 192 320S175.625 316.875 169.375 310.625L9.375 150.625C3.125 144.375 0 136.188 0 128C0 109.721 14.947 96 32 96C40.188 96 48.375 99.125 54.625 105.375L192 242.75L297.375 137.375C303.625 131.125 311.812 128 320 128S336.375 131.125 342.625 137.375L512 306.75V224C512 206.328 526.312 192 544 192S576 206.328 576 224V384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendDown);
export default __webpack_public_path__ + "static/media/arrow-trend-down.f7de8d17eb7f4fd0a21f9cd677f4a082.svg";
export { ForwardRef as ReactComponent };